__turbopack_context__.v({
  "animatedContainer": "AnimateContainer-module-scss-module__Der-Oq__animatedContainer",
  "fadeIn": "AnimateContainer-module-scss-module__Der-Oq__fadeIn",
  "fadeOut": "AnimateContainer-module-scss-module__Der-Oq__fadeOut",
});
